module.exports = __webpack_public_path__ + "static/media/footerC.284957a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/footerC.png
// module id = 791
// module chunks = 2